<template>
  <ModalDialog
    ref="dialog"
    title="Xero Query"
    icon="fa-search"
    :scrollable="false"
    @closed="onClosed"
    :showSubmit="false">

    <FormGroup v-bind:form="form" :labelColumnSize="2">
      <ContentTitle>Query Xero</ContentTitle>

      <div>
        <FormRow label="Account">
          <FormStaticLabel>{{ accountName }}</FormStaticLabel>
        </FormRow>

        <FormRow label="Resource">
          <FormSelect :options="resourceNameLookup" v-model="queryInfo.resourceName" field="resourceName" />          
        </FormRow>
        <FormRow label="Field">
          <FormSelect :options="fieldNameLookup" v-model="queryInfo.fieldName" field="fieldName" />          
        </FormRow>
        <FormRow label="Search Text">
          <FormInputText v-model="queryInfo.searchValue" field="searchValue" placeholder="Search Text" />          
        </FormRow>

        <FormButton class="btn-primary" @click="searchXeroClicked" :loading="submitting"><i class="far fa-search" /> Search</FormButton>
      </div>
    </FormGroup>

    <div class="mt-3" v-if="searchResults">
      <ContentTitle>Results</ContentTitle>
      <div class="query-results">
        <pre>{{ searchResults }}</pre>
      </div>
    </div>
  </ModalDialog>
</template>

<style scoped>
.query-results {
  max-height: 300px;
  overflow: auto;
}
</style>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'DeveloperXeroQueryDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    accountId: Number,
    accountName: String
  },
  data() {
    return {
      queryInfo: {
        resourceName: 'contacts',
        fieldName: 'Name',
        searchValue: ''
      },
      searchResults: '',
      form: {},
      submitting: false
    }
  },
  computed: {
    resourceNameLookup() {
      return [
        { value: 'contacts', name: 'Contacts' },
        { value: 'invoices', name: 'Invoices' },
        { value: 'overpayments', name: 'Overpayments' },
        { value: 'payments', name: 'Payments' },
        { value: 'creditnotes', name: 'Credit Notes' }        
      ]
    },
    fieldNameLookup() {
      if(this.queryInfo.resourceName === 'contacts') {
        return [
          { value: 'Name', name: 'Name' }
        ]
      }
      if(this.queryInfo.resourceName === 'invoices') {
        return [
          { value: 'InvoiceNumber', name: 'InvoiceNumber' },
          { value: 'Reference', name: 'Reference' }
        ]
      }
      if(this.queryInfo.resourceName === 'overpayments') {
        return [
          { value: 'Reference', name: 'Reference' },
          { value: 'Total', name: 'Total', type: 'number' }
        ]
      }
      if(this.queryInfo.resourceName === 'payments') {
        return [
          { value: 'Reference', name: 'Reference' }
        ]
      }
      if(this.queryInfo.resourceName === 'creditnotes') {
        return [
          { value: 'CreditNoteNumber', name: 'CreditNoteNumber' },
          { value: 'Reference', name: 'Reference' }
        ]
      }

      return []
    }
  },
  watch: {
    'queryInfo.resourceName': function() {
      this.queryInfo.fieldName = ''
      if(this.fieldNameLookup.length > 0)
        this.queryInfo.fieldName = this.fieldNameLookup[0].value
    },
  },
  mounted() {
  },
  methods: {
    show() {
      this.form = {}
      this.submitting = false

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    searchXeroClicked() {
      this.submitting = true

      var fieldInfo = this.fieldNameLookup.find(f => f.value === this.queryInfo.fieldName)

      var queryInfo = {
        resourceName: this.queryInfo.resourceName,
        fieldName: this.queryInfo.fieldName,
        searchValue: this.queryInfo.searchValue,
        fieldType: 'string'
      }

      if(fieldInfo && fieldInfo.type)
        queryInfo.fieldType = fieldInfo.type

      this.$apiService.developerService.developerGetXeroQuery(this.accountId, queryInfo)
        .then(response => {
          this.searchResults = JSON.stringify(response.data, null, 2)
        })
        .catch(err => {
          this.$data.form = this.processFormResponse(err)
        })
        .finally(() => {
          this.submitting = false
        })
    }
  }
}
</script>